import React from 'react';
import { RequestTab, LibraryTab, HTMLViewer, Container, ContentArea, TabBar, Tab } from './components';
import { useFlashCheck } from './hooks/useFlashCheck';
import { TabType } from './types';

const FlashCheckPage: React.FC = () => {
  const {
    activeTab,
    files,
    loading,
    error,
    viewingFile,
    loadingFileUrl,
    getFilteredFiles,
    handleHTMLFileClick,
    handleTabChange,
    clearError,
    closeHTMLViewer
  } = useFlashCheck();

  const handleTabClick = (tab: TabType) => {
    handleTabChange(tab);
    clearError(); // Clear errors when switching tabs
  };

  return (
    <>
      <Container>
        {/* Inlined Tab Navigation */}
        <TabBar>
          <Tab 
            $active={activeTab === 'library'} 
            onClick={() => handleTabClick('library')}
          >
            📚 Library
          </Tab>
          <Tab 
            $active={activeTab === 'request'} 
            onClick={() => handleTabClick('request')}
          >
            📝 Request FlashCheck
          </Tab>
        </TabBar>

        <ContentArea>
          {activeTab === 'request' ? (
            <RequestTab
              loading={loading}
              error={error}
            />
          ) : (
            <LibraryTab
              files={files}
              loading={loading || loadingFileUrl}
              error={error}
              getFilteredFiles={getFilteredFiles}
              handleHTMLFileClick={handleHTMLFileClick}
            />
          )}
        </ContentArea>
      </Container>

      {/* HTML Viewer Modal */}
      {viewingFile && (
        <HTMLViewer
          fileUrl={viewingFile.url}
          fileName={viewingFile.fileName}
          onClose={closeHTMLViewer}
        />
      )}
    </>
  );
};

export default FlashCheckPage;